import ConstituentExportFieldName from '@/constants/constituents/ConstituentExportFieldName';
import translate from '@/lib/intl/translate';
import type ConstituentExportField from '@/types/api/ConstituentExportField';

const ConstituentExportBasicProfileFields: Omit<
  ConstituentExportField,
  'value'
>[] = [
  {
    fieldLabel: translate('DONOR_PREFIX'),
    fieldName: ConstituentExportFieldName.PREFIX,
  },
  {
    fieldLabel: translate('FIRST_NAME_LABEL'),
    fieldName: ConstituentExportFieldName.FIRST_NAME,
  },
  {
    fieldLabel: translate('LAST_NAME_LABEL'),
    fieldName: ConstituentExportFieldName.LAST_NAME,
  },
  {
    fieldLabel: translate('COMPANY_NAME_LABEL'),
    fieldName: ConstituentExportFieldName.ORG_NAME,
  },
  {
    fieldLabel: translate('CATEGORIES'),
    fieldName: ConstituentExportFieldName.CATEGORIES,
  },
  {
    fieldLabel: translate('BIRTHDAY_LABEL'),
    fieldName: ConstituentExportFieldName.DOB,
  },
  {
    fieldLabel: translate('CONSTITUENT_ASSIGNEE'),
    fieldName: ConstituentExportFieldName.ASSIGNEES,
  },
  {
    fieldLabel: translate('EMAIL_ADDRESSES_LABEL'),
    fieldName: ConstituentExportFieldName.PRIMARY_EMAIL,
  },
  {
    fieldLabel: translate('PHONE_NUMBERS_LABEL'),
    fieldName: ConstituentExportFieldName.PRIMARY_PHONE,
  },
  {
    fieldLabel: translate('MAILING_ADDRESSES_LABEL'),
    fieldName: ConstituentExportFieldName.PRIMARY_ADDRESS,
  },
  {
    fieldLabel: translate('CONSTITUENT_LABELS'),
    fieldName: ConstituentExportFieldName.LABELS,
  },
  {
    fieldLabel: translate('CONSTITUENT_BIO_LABEL'),
    fieldName: ConstituentExportFieldName.BIO,
  },
  {
    fieldLabel: translate('DONOR_GIVING_SUMMARY'),
    fieldName: ConstituentExportFieldName.GIVING_SUMMARY,
  },
  {
    fieldLabel: translate('EXTERNAL_ID'),
    fieldName: ConstituentExportFieldName.EXT_CONSTITUENT_ID,
  },
];

export default ConstituentExportBasicProfileFields;
